//@flow

import parsePhoneNumber, {parsePhoneNumberFromString} from 'libphonenumber-js';
import {useState, useEffect} from 'react';
import {useStoreCountry} from '../../modules/country/utils';

export function formatPhoneNumber(phone: string): string {
  const hasPlus = phone.startsWith('+');

  const phoneToFormat = hasPlus ? phone : `+${phone}`;

  const phoneNumber = parsePhoneNumber(phoneToFormat);

  if (!phoneNumber) return phone;

  return phoneNumber.formatInternational();
}

export function validatePhoneNumber(
  phone: string,
  countryCode?: string
): boolean {
  const phoneNumber = parsePhoneNumber(phone, countryCode);

  if (!phoneNumber) return false;

  return phoneNumber.isValid();
}

type PhoneValidationOptions = {
  initialPhone?: string,
  manualValidation?: boolean,
};

export function usePhoneValidation({
  initialPhone = '',
  manualValidation,
}: PhoneValidationOptions) {
  const [phone, setPhone] = useState<string>(initialPhone);
  const [validPhone, setValidPhone] = useState(false);

  const country = useStoreCountry();

  useEffect(() => {
    if (manualValidation) return;

    if (phone.length > 0) {
      setValidPhone(validatePhoneNumber(phone, country.code));
    }
  }, [country.code, manualValidation, phone]);

  const validate = (phoneNumber: string = '') => {
    if (phoneNumber) setPhone(phoneNumber);
    const phoneToValidate = phoneNumber || phone;
    const valid = validatePhoneNumber(phoneToValidate, country.code);
    setValidPhone(valid);
    return valid;
  };

  return {
    phone,
    setPhone,
    validPhone,
    validate,
  };
}

export function sanitizePhoneNumber(phone: string) {
  const startWithPrefix = phone?.startsWith('+');
  const number = startWithPrefix ? phone : `+${phone}`;
  const phoneNumber = parsePhoneNumberFromString(number);

  if (!phoneNumber) return '';

  return phoneNumber.number.replace('+', '');
}
